import { ICrop, IVariety } from "./exports"


export function getSeedPlanDefaults(crop?: ICrop, variety?: IVariety) {

    var defaults = {
        GerminationRate: 0.94,
        TGW: 50,
    }

    if (crop) {
        if (crop.TGW) defaults.TGW = crop.TGW
        if (crop.GerminationRate) defaults.GerminationRate = crop.GerminationRate
    }

    if (variety) {
        if (variety.TGW) defaults.TGW = variety.TGW
        if (variety.GerminationRate) defaults.GerminationRate = variety.GerminationRate
    }

    return defaults

}
